import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import logos from '../../images/absherr.png'
import './Auth.css'
import { useDispatch, useSelector } from "react-redux";
import { AuthLogin } from '../../Redux/Actions/ActionAuth';

function Login() {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const [loadBtn, setloadBtn] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const RoutToHome = event => {
        event.preventDefault();
        dispatch(AuthLogin(email, password, navigate, setloadBtn));
    }
    return (
        <div className="container3">
            <div className="screen">
                <div className="screen__content">
                    <form className="login">
                        <img src={logos} />
                        <div className="login__field">
                            <i className="login__icon fa fa-envelope"></i>
                            <input type="email" className="login__input" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div className="login__field">
                            <i className="login__icon fa fa-lock"></i>
                            <input type="password" className="login__input" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                        </div>
                        <button className="button login__submit" onClick={RoutToHome} >
                            {
                                loadBtn ? "Loading ..." :
                                    <>
                                        <span className="button__text">Log In Now</span>
                                        <i className="button__icon fa fa-chevron-right"></i>
                                    </>
                            }
                        </button>
                    </form>
                </div>
                <div className="screen__background">
                    <span className="screen__background__shape screen__background__shape4"></span>
                    <span className="screen__background__shape screen__background__shape3"></span>
                    <span className="screen__background__shape screen__background__shape2"></span>
                    <span className="screen__background__shape screen__background__shape1"></span>
                </div>
            </div>
        </div>
    )
}

export default Login